import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-form-input-date',
  templateUrl: './form-input-date.component.html',
  styleUrls: ['./form-input-date.component.sass']
})
export class FormInputDateComponent implements OnInit {
  @ViewChild('dp') datepicker!: BsDatepickerDirective;
  @ViewChild('dateInput') dateInput!: ElementRef;
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() required: boolean = false;
  @Input() formName: any;
  @Input() control: FormControl = new FormControl();
  @Input() error: boolean = false;
  @Input() errorMessage: string = '';
  @Input() htmlId: string = '';
  @Input() toolTipMessage: string = '';

  bsConfig: Partial<BsDatepickerConfig> = {
    isAnimated: true,
    adaptivePosition: true,
    dateInputFormat: 'DD/MM/YYYY',
    containerClass: 'theme-dark-blue',
    showWeekNumbers: false,
    showTodayButton: true
  };

  constructor() { }

  ngOnInit() {
    // Initialize the datepicker with default value if control has one
    if (this.control.value) {
      this.control.setValue(this.control.value);
    }
  }

  openDatepicker() {
    if (this.datepicker) {
      this.datepicker.toggle();
    }
  }

  onInputClick(event: MouseEvent) {
    // Prevent the default click behavior
    event.preventDefault();
    event.stopPropagation();

    // Use a timeout to ensure the datepicker is ready
    setTimeout(() => {
      if (this.datepicker && !this.datepicker.isOpen) {
        this.datepicker.show();
      }
    }, 50);
  }
}
